import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../../styles/StudentReviews.css";
import '../../styles/PursueMBA.css';
import { QoteImage } from '../../assets/index';
import { getTestimonial } from '../../services/getAdminApi';
import { Pagination, Navigation, Autoplay } from "swiper/modules";

const StudentReviews = () => {
  // Initialize state to store testimonials
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    console.log("ENV: ", "https://console.fbsedu.in/storage/app")
    // Fetch testimonials from API
    getTestimonial()
      .then((response) => {
        // If the response contains data, update the state
        if (response && response.data) {
       
          setTestimonials(response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching testimonials:", error);
      });
  }, []);

  return (
    <>
      <div className="testimonial-slider-container">
        <div className='head_container'>
          <div className="line"></div>
          <h1 className="title">Students Testimonials</h1>
        </div>
        
        {/* Swiper component to display testimonials */}
        <Swiper
          slidesPerView={3}
          spaceBetween={30}
          pagination={{ clickable: true }}
          navigation={true}
          autoplay={{
            delay: 3000, // Auto-slide every 3 seconds
            disableOnInteraction: false, // Keep autoplay running even after interaction
          }}
          breakpoints={{
            320: {
              slidesPerView: 1, 
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2, 
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3, 
              spaceBetween: 30,
            },
          }}
          modules={[Pagination, Navigation, Autoplay]}
          className="testimonial-swiper"
        >
          {/* Map over the testimonials data and render them */}
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={testimonial.id}>
              <div className="testimonial-card">
                <div className="quote">
                  <img src={QoteImage} alt="Quotes Icon" className="qicon" />
                </div>
                {/* Render student photo */}
                <img
                  className="avatar"
                  src={`${"https://console.fbsedu.in/storage/app"}/${testimonial.student_photo}`}
                  alt={`${testimonial.student_name}'s avatar`}
                />
               
                <p className="testimonial-text">{testimonial.description}</p>
               
                <p className="name">{testimonial.student_name}</p>
              
                <p className="role">{testimonial.company_name}</p>
                <div className="logos">
                 
                  <div className="company-logo-container">
                    <img
                      className="company-logo"
                      src={`${"https://console.fbsedu.in/storage/app"}/${testimonial.company_logo}`}
                      alt={`${testimonial.company_name} logo`}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default StudentReviews;
